import * as Sentry from "@sentry/capacitor";

import { Role } from "@/Common/Models/Domain/Role";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { useChatStore } from "../Store";
import { useUserStore } from "@/Modules/User/Store";
import { useAppStore } from "@/Modules/App/Store";

import { acceptChangeSessionDuration } from "@/Services/TherapyApi/Chat";

import { transformChatApiToChatRoom } from "../Transformers/Chat";

import { hasValue } from "@/Utils/Objects";

const AcceptChangeDurationAH = async (chatUuid: string): Promise<boolean> => {
  const chatStore = useChatStore();
  const userStore = useUserStore();
  const appStore = useAppStore();

  const chatApi = await acceptChangeSessionDuration(chatUuid).catch(() => undefined);

  if (hasValue(chatApi)) {
    const previousEvents = chatStore.rooms[chatUuid]?.events ?? [];
    const chatRoom = transformChatApiToChatRoom(chatApi, Role.THERAPIST, previousEvents, userStore.user!);

    chatRoom.isLoadingEvents = false;

    chatStore.rooms[chatUuid] = chatRoom;

    return true;
  } else {
    appStore.showSnackbar({
      message: "chat.change_session_duration.error.accept",
      type: NotificationType.ERROR,
    });

    Sentry.captureMessage("AcceptChangeDurationAH chatApi is undefined");
  }

  return false;
};

export default AcceptChangeDurationAH;
